import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Sobre from "./components/Sobre";
import Pessoas from "./components/Pessoas";
import Pesquisa from "./components/Pesquisa";
import Calendario from "./components/Calendario";
import Footer from "./components/Footer";
import Login from "./components/Admin/Login";
import AdminDashboard from "./components/Admin/AdminDashboard";
import ProtectedRoute from "./components/Admin/ProtectedRoute";
import "./App.css";

function HomePage() {
  return (
    <div className="App">
      <Header />
      <main className="App-main">
        <Sobre />
        <Pessoas />
        <Pesquisa />
        <Calendario />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
